<template>
    <nav class="SkipLinks" role="navigation" :aria-label="localizations[lang].skipLinks.navLabel">
        <button v-if="uiHidden" type="button" class="SkipLink" @click="showControls">
            {{ localizations[lang].skipLinks.showControls }}
        </button>
    </nav>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'SkipLinks',
    computed: {
        ...mapState(['uiHidden', 'localizations', 'lang']),
    },
    methods: {
        ...mapActions(['toggleUi']),
        showControls() {
            this.toggleUi({ uiHidden: false });
            // After UI is shown, focus on the first control
            this.$nextTick(() => {
                const header =
                    document.getElementById('ReaderHeader') || document.querySelector('[dusk="ReaderHeader"]');
                if (header) {
                    const focusable = header.querySelector(
                        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                    );
                    if (focusable) {
                        focusable.focus();
                    }
                }
            });
        },
    },
};
</script>

<style>
/* ============================================
   SkipLinks - Accessibility skip navigation
   ============================================ */

.SkipLinks {
    @apply absolute left-0 top-0 z-[9999] flex gap-2 p-2;
}

.SkipLink {
    @apply absolute -left-[9999px] top-auto h-px w-px cursor-pointer overflow-hidden whitespace-nowrap rounded-lg bg-gray-50 px-6 py-4 text-base font-semibold no-underline dark:bg-gray-800;
    color: var(--theme-accent-color, #000);
}

.SkipLink:focus {
    @apply fixed left-4 top-4 h-auto w-auto outline-none ring-2 ring-blue-500 ring-offset-2;
}

.SkipLink:focus + .SkipLink:focus {
    left: calc(1rem + 200px);
}

/* ============================================
   Theme Support
   ============================================ */

/* Dark mode */
.Reader[data-theme='dark'] .SkipLink {
}

/* High Contrast Dark mode */
.Reader[data-theme='high-contrast-dark'] .SkipLink {
    @apply shadow-none;
    border: 2px solid #ffffff;
}
</style>
